import { Income } from '../../../member-profile/components/Income';

export default function () {
    return <Income />;
}
